type Props = {
  width?: string
  height?: string
  startColor?: string
  endColor?: string
}

export default function AIStarsIcon({
  width = '8',
  height = '8',
  startColor,
  endColor,
}: Props) {
  const g0 = 'paint0_linear_6593_233'
  const g1 = 'paint1_linear_6593_233'
  const g2 = 'paint2_linear_6593_233'

  const fill0 = startColor && endColor ? `url(#${g0})` : 'url(#paint0_linear_6593_233)'
  const fill1 = startColor && endColor ? `url(#${g1})` : 'url(#paint1_linear_6593_233)'
  const fill2 = startColor && endColor ? `url(#${g2})` : 'url(#paint2_linear_6593_233)'

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 8 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M6.27819 4.88087L8 4.40041L6.27819 3.91943L6.66228 3.23773L5.98051 3.6223L5.5 1.90015L5.01949 3.6223L4.33772 3.23773L4.72181 3.91943L3 4.40041L4.72181 4.88087L4.33772 5.56256L5.01949 5.17799L5.5 6.90015L5.98051 5.17799L6.66228 5.56256L6.27819 4.88087Z" fill={fill0} />
      <path d="M1.9002 0.300049L2.05519 0.952826C2.16031 1.39502 2.50523 1.73994 2.94742 1.84505L3.6002 2.00005L2.94742 2.15505C2.50523 2.26016 2.16031 2.60508 2.05519 3.04727L1.9002 3.70005L1.7452 3.04727C1.64008 2.60508 1.29516 2.26016 0.852972 2.15505L0.200195 2.00005L0.852972 1.84505C1.29516 1.73994 1.64008 1.39502 1.7452 0.952826L1.9002 0.300049Z" fill={fill1} />
      <path d="M1.3 5.1001L1.4187 5.59937C1.49877 5.93709 1.76254 6.20133 2.10072 6.2814L2.6 6.4001L2.10072 6.51879C1.76301 6.59887 1.49877 6.86263 1.4187 7.20082L1.3 7.7001L1.1813 7.20082C1.10123 6.8631 0.837464 6.59887 0.499275 6.51879L0 6.4001L0.499275 6.2814C0.836993 6.20133 1.10123 5.93756 1.1813 5.59937L1.3 5.1001Z" fill={fill2} />
      <defs>
        <linearGradient id={g0} x1="3" y1="2.42051" x2="8.57107" y2="2.96971" gradientUnits="userSpaceOnUse">
          <stop stopColor={startColor || '#8A65E9'} />
          <stop offset="1" stopColor={endColor || '#6636E2'} />
        </linearGradient>
        <linearGradient id={g1} x1="0.200195" y1="0.653897" x2="3.98853" y2="1.02735" gradientUnits="userSpaceOnUse">
          <stop stopColor={startColor || '#8A65E9'} />
          <stop offset="1" stopColor={endColor || '#6636E2'} />
        </linearGradient>
        <linearGradient id={g2} x1="0" y1="5.37069" x2="2.89696" y2="5.65627" gradientUnits="userSpaceOnUse">
          <stop stopColor={startColor || '#8A65E9'} />
          <stop offset="1" stopColor={endColor || '#6636E2'} />
        </linearGradient>
      </defs>
    </svg>
  )
}
